import React, { useState } from "react";
import Staking from "../../screens/Staking";
import { GoCopy } from "react-icons/go";
import { FaRegStar, FaStar } from "react-icons/fa";
import ROI from "./ROI";
import LeaderShipModal from "../LeaderShipBonus/LeaderShipBonus";
// import Web3 from "web3";
import {
  CopyToClipboard,
  PartnerIcon,
  CycleIcon,
} from "react-copy-to-clipboard";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Web3 from "web3";

const StakeComponent = (props) => {
  const [tabs, setTabs] = useState("staking");
  const [isModalOpen, setIsModalOpen] = useState(false);


  const addressCopy_notify = () => toast("address is Copied!");

  const link_notify = () => toast("Referral Link Copied!");



  function weiToEth(wei) {
    const web3 = new Web3();
    return web3.utils.fromWei(wei.toString(), "ether");
}



  return (
    <div className="container tw-relative tw-pt-11 ">
      <LeaderShipModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <div className="row    g-5">
        <div className="col-lg-6">
          <div className=" row">
            <ROI total_withdraw_reward={props.total_withdraw_reward}exorUsdPrice={props.exorUsdPrice} totalReferralsEarning={props.totalReferralsEarning} maximum_investment={props.maximum_investment} withdrawFee={props.withdrawFee} set_withdraw_Amount={props.set_withdraw_Amount} availBalance={props.availBalance} withdraw_Amount={props.withdraw_Amount} setInvestment={props.setInvestment}  minimum_investment={props.minimum_investment} Invest={props.Invest}  total_withdraw_reaward={props.total_withdraw_reaward} WithdrawReward={props.WithdrawReward} investment={props.investment} address={props.address}/>
          </div>
        </div>
        <div className="col-lg-6 tw-relative">
          <img src={require("../../assets/images/rounded_bg.png")} className=" tw-absolute tw-top-0 tw-z-[-1000000] tw-right-0" alt="" />
            <div className=" row  g-4">
            <div className=" col-md-12">
              <div className="right-panel-card tw-flex tw-gap-6 tw-items-center tw-rounded-3xl p-4">
                <div className=" tw-relative">
                  <img
                    src={require("../../assets/images/profile.png")}
                    className="  tw-rounded-full"
                    alt=""
                  />
                  
                  {/* <div className="   tw-flex tw-gap-1 tw-bg-[#20193A] pl-2 tw-border tw-border-[#413A5B] tw-absolute tw-bottom-0 tw-w-full tw-rounded-full"> 

                      <p  style={{text:'white'}} className=" m-0 pl-2 tw-text-white tw-text-center tw-items-center " >{props.rank>0?"Rank A"+props.rank:"Rank A0"} </p>
                      </div> */}

                </div>
                <div>
                  <h6 className="  tw-text-white  tw-font-poppins tw-flex tw-gap-3  tw-items-center">
                   {props.address ? props.address.slice(0,4)+"..."+ props.address.slice(39,42):"kindly connect"}
                  {" "}
                  <CopyToClipboard
                        text={props.address? props.address:""}
                        >
                    <GoCopy onClick={addressCopy_notify}  size={23} className="  tw-text-[white]" />
                    </CopyToClipboard>

                  </h6>
                  <span className="   tw-text-white tw-font-poppins tw-text-md">
                    Upline ID: {props.upliner ? props.upliner.slice(0,4)+"..."+ props.upliner.slice(39,42):""}
                  </span>
                </div>
              </div>
            </div>
            {/* <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-3xl p-4">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Earned Amount
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                {Number(props.RoiEarning)>0?((Number(props.RoiEarning)/10**18)+(Number(props.totalEarned)/10**18)):0}
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>
                
              </div>
            </div> */}

            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Income
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.totalEarning)>0?(Number(props.totalEarning)/10**18):0}
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>
                
              </div>
            </div>

            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Current Balance
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.availBalance)>0?(Number(props.availBalance)/10**18):0}
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>
              </div>
            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  ROI Earning
                </h6>

                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.RoiEarning)>0?(Number(props.RoiEarning)/10**18):0}
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>
              </div>
            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Self Investment
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  { (Number(props.totlaInvestment)>0? (weiToEth(props.totlaInvestment)): 0) }  
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>
            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Withdraw
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                {Number(props.total_withdraw_reward)>0?(Number(props.total_withdraw_reward)/10**18):0} 
                
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>
            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Referrals
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.directs)}
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>
            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Direct Earnings
                </h6>
                <span className="  tw-text-white  tw-font-sm  tw-font-poppins tw-text-sm">
                    Hold  : 
                  </span>
                  <span className="   tw-text-white tw-font-poppins tw-text-sm">
                  : {(Number(props.hold_amount)/10**18)} |
                  </span>
                  <span className="  tw-text-white  tw-font-sm  tw-font-poppins tw-text-sm">
                     | Released  : 
                  </span>
                  <span className="   tw-text-white tw-font-poppins tw-text-sm">
                  : {(Number(props.totalReferralsEarning)/10**18) } 
                  </span>
                {/* <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.todayEarning)>0?(Number(props.todayEarning)/10**18):0} 
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span> */}

              </div>

            </div>
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Team
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.team)>0?(Number(props.team)):0} 
                </span>
                {/* <span className="  tw-text-white  tw-font-sm"> WLB</span> */}

              </div>

            </div>

            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-2xl p-3">
                <h6 className="   tw-text-white  tw-font-inter ">
                  Total Team Business
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.teamBusiness)>0?(Number(props.teamBusiness)/10**18):0} 
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>

            </div>


            <div className=" col-md-6">
              <div className="right-panel-card tw-cursor-pointer tw-rounded-3xl p-4">
                <div className=" tw-flex tw-justify-between tw-items-center tw-z-[1000000]">
                  <h6 className="   tw-text-white  tw-font-inter ">
                     Rank Bonus 
                  </h6>
                  <img
                    onClick={() => setIsModalOpen(true)}
                    src={require("../../assets/images/bouns.png")}
                    alt=""
                  />
                </div>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                  {Number(props.MatchingEarning)>0?(Number(props.MatchingEarning)/10**18):0} 
                  
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>
            </div>


            
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-3xl p-4">
                <h6 className="   tw-text-white  tw-font-inter ">
                Super Leg Business
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                {Number(props.super_leg_bal)>0?(Number(props.super_leg_bal)/10**18):0} 
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>

            </div>
            
            <div className=" col-md-6">
              <div className="right-panel-card tw-rounded-3xl p-4">
                <h6 className="   tw-text-white  tw-font-inter ">
                Other Legs Business
                </h6>
                <span className="  tw-text-white  tw-font-medium  tw-font-inter tw-text-2xl">
                {Number(props.other_leg_bal)>0?(Number(props.other_leg_bal)/10**18):0} 
                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div>

            </div>
            <div className=" col-md-12">
            {/* <div className="right-panel-card tw-rounded-3xl p-4">
                <h6 className="  tw-text-white  tw-font-poppins tw-flex tw-gap-3  tw-justify-between tw-items-center">
                Fast Track Bonus

                </h6>
                <span className=" tw-font-inter tw-text-white  tw-text-2xl">
                {Number(props.total_principle_return)>0?(Number(props.total_principle_return)/10**18):0} 

                </span>
                <span className="  tw-text-white  tw-font-sm"> WLB</span>

              </div> */}
              <div className="right-panel-card tw-mt-5 tw-rounded-2xl p-3">
                <h6 className="  tw-text-white  tw-font-poppins tw-flex tw-gap-3  tw-justify-between tw-items-center">
                Invite Link
                <CopyToClipboard
                        text={`${window.location.host}/?ref=${props.address? props.address:""}`}
                    >
                   <GoCopy  onClick={link_notify}  size={23} color="#fff" />
                  </CopyToClipboard>

                </h6>
                <span className="invite-link-url tw-font-poppins tw-text-md">
                {window.location.host}/?ref={props.address?props.address.slice(0,4)+"..."+props.address.slice(39,42):"kindly connect"}
                </span>
              </div>

            </div>
          </div>
          
        </div>
      </div>
      <ToastContainer />

    </div>
  );
};

export default StakeComponent;
